export const baseURL = process.env.REACT_APP_API_URL;

export const PERMISSIONS = {
    VIEW_HOME: '1_/home',
}

//export const PERMISSION_ENDPOINT = baseURL+'/perm/manage';
